'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _navigationActions = require('../../../reducers/navigationActions');

var _changePasswordActions = require('./changePasswordActions');

var _ChangePasswordSuccessModal = require('./ChangePasswordSuccessModal');

var _ChangePasswordSuccessModal2 = _interopRequireDefault(_ChangePasswordSuccessModal);

var _ChangePasswordInputModal = require('./ChangePasswordInputModal');

var _ChangePasswordInputModal2 = _interopRequireDefault(_ChangePasswordInputModal);

var _ChangePasswordExpiredModal = require('./ChangePasswordExpiredModal');

var _ChangePasswordExpiredModal2 = _interopRequireDefault(_ChangePasswordExpiredModal);

var _GenericErrorModal = require('../../../components/error/modals/components/GenericErrorModal');

var _GenericErrorModal2 = _interopRequireDefault(_GenericErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Redux connect methods
var mapStateToProps = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'modal', 'changePassword']);
}, function (changePasswordModalState) {
    return changePasswordModalState.toJS();
});

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit: function onSubmit(_ref) {
            var password = _ref.password;
            return dispatch((0, _changePasswordActions.passwordChangeSubmitted)({ password: password }));
        },
        dispatchPasswordChangeCodeNotFound: function dispatchPasswordChangeCodeNotFound() {
            return dispatch((0, _changePasswordActions.passwordChangeCodeNotFound)());
        },
        dispatchFetchPasswordResetCodeDetails: function dispatchFetchPasswordResetCodeDetails(code) {
            return dispatch((0, _changePasswordActions.fetchPasswordResetCodeDetails)(code));
        },
        dispatchNavigateToLogin: function dispatchNavigateToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        },
        dispatchNavigateToForgotPassword: function dispatchNavigateToForgotPassword(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToForgotPassword)());
        }
    };
};

var ChangePasswordModal = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(ChangePasswordModal, _React$Component);

    function ChangePasswordModal() {
        _classCallCheck(this, ChangePasswordModal);

        return _possibleConstructorReturn(this, (ChangePasswordModal.__proto__ || Object.getPrototypeOf(ChangePasswordModal)).apply(this, arguments));
    }

    _createClass(ChangePasswordModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                location = _props.location,
                dispatchFetchPasswordResetCodeDetails = _props.dispatchFetchPasswordResetCodeDetails,
                dispatchPasswordChangeCodeNotFound = _props.dispatchPasswordChangeCodeNotFound;


            if (!location.query || !location.query.code) return dispatchPasswordChangeCodeNotFound();

            var code = location.query.code;

            dispatchFetchPasswordResetCodeDetails(code);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                dispatchNavigateToLogin = _props2.dispatchNavigateToLogin,
                dispatchNavigateToForgotPassword = _props2.dispatchNavigateToForgotPassword,
                passwordUpdated = _props2.passwordUpdated,
                isExpired = _props2.isExpired,
                isError = _props2.isError,
                isLoading = _props2.isLoading,
                error = _props2.error;


            if (isLoading) return null;

            if (isError) return _react2.default.createElement(_GenericErrorModal2.default, { error: error, showActions: true });

            if (isExpired) {
                return _react2.default.createElement(_ChangePasswordExpiredModal2.default, { navigateToLogin: dispatchNavigateToLogin,
                    navigateToForgotPassword: dispatchNavigateToForgotPassword });
            }

            return passwordUpdated ? _react2.default.createElement(_ChangePasswordSuccessModal2.default, { navigateToLogin: dispatchNavigateToLogin }) : _react2.default.createElement(_ChangePasswordInputModal2.default, this.props);
        }
    }]);

    return ChangePasswordModal;
}(_react2.default.Component)) || _class);
exports.default = ChangePasswordModal;


ChangePasswordModal.propTypes = {
    loginSubmit: _propTypes2.default.func,
    dispatchNavigateToLogin: _propTypes2.default.func,
    dispatchNavigateToForgotPassword: _propTypes2.default.func,
    dispatchFetchPasswordResetCodeDetails: _propTypes2.default.func,
    dispatchPasswordChangeCodeNotFound: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    location: _propTypes2.default.object.isRequired,
    passwordUpdated: _propTypes2.default.bool,
    isExpired: _propTypes2.default.bool,
    isError: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.object
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/ChangePasswordModal.js
// module id = 1673
// module chunks = 0